export default __webpack_public_path__ + "b45fc3898415783c7f67bfdc02fed4ac.png";